import { createContext, useContext } from 'react'
import type { User as FirebaseUser } from 'firebase/auth'
import type { User } from '@/types'

export interface AuthContextValue {
  firebaseUser: FirebaseUser | null
  userProfile: User | null
  loading: boolean
  isAdmin: boolean
  signIn: (email: string, password: string) => Promise<void>
  signOut: () => Promise<void>
}

// Thrown by signIn when the account exists but lacks the admin role; the UI owns the wording.
export class AdminAccessDeniedError extends Error {
  constructor() {
    super('Access denied. Admin role required.')
    this.name = 'AdminAccessDeniedError'
  }
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
